import type { JSX } from "react";

import { ScriptIcon } from "@expert/common-ui/assets";
import { MarkdownViewer } from "@expert/solve-tools";
import { Anchor, Group, Stack, Text } from "@mantine/core";

import { markdownOverrides } from "../customer-verification/markdownOverrides";
import { HandoffTag } from "./HandoffTag";
import classes from "./styles.module.css";

interface IVRSummaryProps {
    intent?: string;
    summary?: string;
    productLink?: string;
    productTitle?: string;
}

export function IVRSummary({
    intent,
    summary = "No summary info available",
    productLink,
    productTitle,
}: IVRSummaryProps): JSX.Element {
    return (
        <Stack gap={0}>
            <Stack align="center" gap="xs" pt="md" pb="sm">
                <Group gap="xs">
                    <ScriptIcon />
                    <Text c="dark.3">Confirm: </Text>
                </Group>
                <Text fw="bold">{"\u201CSounds like you\u2019re calling about...\u201D"}</Text>
            </Stack>
            <Stack className={classes.summary} p="sm" mt="sm" fz="sm" gap="xxs">
                {intent && (
                    <Group gap="xs" pb="xxs">
                        <HandoffTag>{intent}</HandoffTag>
                    </Group>
                )}
                <MarkdownViewer content={summary} options={{ overrides: markdownOverrides }} />
                {productTitle && (
                    <Stack gap="4xs">
                        <Text size="xs" c="gray.5">
                            Product details
                        </Text>
                        <Text size="xs" c="gray.1">
                            {productTitle}
                        </Text>
                    </Stack>
                )}
                {productLink && (
                    <Group gap="xs" pb="xxs">
                        <Anchor href={productLink} fz="xs" size="sm" target="_blank" underline="always">
                            Product link
                        </Anchor>
                    </Group>
                )}
            </Stack>
        </Stack>
    );
}
